(ns rothko.accordion.component
  (:require [reagent.core :as r]
            [rothko.icon.component :refer [icon]]))

(defn accordion
  [{:keys [open icon-size]
    :or {open #{}
         icon-size 27}} & children]
  (let [!state (r/atom {:open open})
        icon-click-handler (fn [e]
                             ;; TODO use dataset handling code in rothko now
                             (let [key (keyword
                                        (.. (.closest (.. e -target)
                                                      ".accordion__item-title")
                                            -dataset
                                            -key))]
                               (swap! !state update-in [:open]
                                      ;; TODO `toggle` fn on sets in utility-belt?
                                      (if (contains? (:open @!state) key)
                                        disj
                                        conj)
                                      key)))
        when-open (fn [key open closed]
                    (if ((:open @!state) key) open closed))]
    (fn [{:keys [appearance items]} & children]
      [:div.accordion {:class appearance}
       (doall ; a vector here will not work!
        (for [{:keys [content key title] :as item} items
              :when item]
          ^{:key key}
          [:div.accordion__item
           [:div {:class [:accordion__item-title]
                  :data-key key}
            [icon {:icon (when-open key :angle-down :angle-up)
                   :on-click icon-click-handler
                   :size icon-size}]
            title]
           [:div.accordion__item-body
            {:style {:display (when-open key :block :none)}}
            content]]))])))
